import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './KibanaDialog.scss'
import DialogActions from "@material-ui/core/DialogActions";
import Iframe from "../../../Iframe/Iframe";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";


export default class KibanaDialog extends PureComponent {
    constructor(props) {
        super(props);
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    render() {
        return (
            <Dialog
                fullScreen
                className="statistics-dialog"
                open={this.props.open}
                onClose={this.handleClose.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    סטטיסטיקות
                </DialogTitle>
                <DialogContent>
                    <div className="kibana-container">
                        <Iframe url={this.props.kibanaUrl}/>
                    </div>
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <IconButton className="close-button"
                                onClick={this.handleClose.bind(this)}>
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}